
jQuery(document).ready(function ($) {
    // handle cookies
    (function () {
        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
        if ($('.cookie__close').length > 0) {
            $('.cookie__close').click(function () {
                setCookie('ajhkDhSIASN', 1, 365);
                $('.cookie').remove();
            });
        }
    }());
    // toggle archive terms and filter
    $('.terms__open').on('click', function () {
        $('.terms__holder').addClass('terms__holder--active');
        $('body').css('overflow', 'hidden');
    });
    $('.terms__close').on('click', function () {
        $('.terms__holder').removeClass('terms__holder--active');
        $('body').css('overflow', 'initial');
    });
    $('.filter__filter').on('click', function () {
        $('.terms__holder').removeClass('terms__holder--active');
        $('body').css('overflow', 'initial');
    });    // toggle mobile menu
    $('.header-main__open').on('click', function () {
        $('.header-main__navigation').addClass('header-main__navigation--active');
        $('body').css('overflow', 'hidden');
    });
    $('.header-main__close').on('click', function () {
        $('.header-main__navigation').removeClass('header-main__navigation--active');
        $('body').css('overflow', 'initial');
    });
    // toggle search form
    $('.header-main__search-icon, .search-form__icon').on('click', function () {
        $('.search-form__holder').toggleClass('search-form__holder--active');
        $('#search').focus();
    });
    // Sub menu toggle
    $('.menu-item-has-children').on('mouseenter', function () {
        $(this).find('.sub-menu').show();
    });
    $('.menu-item-has-children').on('mouseleave', function () {
        $(this).find('.sub-menu').hide();
    });
    // Product contact toggle
    $('.product-contact__overlay').on('click', function () {
        $('.product-contact__overlay').fadeOut(100);
        $('body').removeClass('capcha');
    });
    $('.product-contact__close').on('click', function () {
        $('.product-contact__overlay').fadeOut(100);
        $('body').removeClass('capcha');

    });
    $('.product-contact__holder').on('click', function (e) {
        e.stopPropagation();
    });
    $('.product-contact--email').on('click', function () {
        $('.product-contact__overlay').fadeIn(100);
        $('body').addClass('capcha');

    });
    // Product gallery swiper
    var gallerySwiper = new Swiper(".gallery-swipper", {
        effect: "fade",
        speed: 400,
        on: {
            slideChange: function () {
                $('.product-thumbs__img').removeClass('product-thumbs__img--active');
                $('.product-thumbs__img[data-index="' + gallerySwiper.activeIndex + '"]').addClass('product-thumbs__img--active');;
            }
        }
    });
    // Product gallery thumbs
    $('.product-thumbs__img').on('click', function () {
        var key = $(this).data('index');
        $('.product-thumbs__img').removeClass('product-thumbs__img--active');
        $(this).addClass('product-thumbs__img--active');
        gallerySwiper.slideTo(key, 400, false);
    });
    // gallery fancy
    $('[data-fancybox]').fancybox({
        backFocus: false
    });
    // favorites swiper
    var swiper = new Swiper(".favorites__swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                //   spaceBetween: 20,
            },
            991: {
                slidesPerView: 3,
                //   spaceBetween: 40,
            },
            1240: {
                slidesPerView: 4,
                //   spaceBetween: 50,
            },
        },
    });
    // home swiper
    var heroSwiper = new Swiper(".hero__swiper", {
        spaceBetween: 0,
        effect: "fade",
        speed: 1000,
        autoplay: {
            delay: 4000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
    $(".hero__swiper").mouseenter(function () {
        heroSwiper.autoplay.stop();
    });
    $(".hero__swiper").mouseleave(function () {
        heroSwiper.autoplay.start();
    });
    // FILTER LOGIC
    // Load filter on enter
    var queryString = window.location.search.replace(/\?/g, '');
    if (queryString.includes('tipas')) {
        ajaxFilter(queryString);
    }
    // AJAX CALL FUNCTION
    function ajaxFilter(data) {
        $('.filter__overlay').fadeIn(100);
        window.history.replaceState('', '', '?' + data);
        $.ajax({
            url: $("#main-filter-form").attr('action'),
            data: data,
            method: 'post',
            success: function (data) {
                $('.results_row').html(data);
                $('.filter__overlay').fadeOut(100);
            },
            error: function (error) {
                console.log(error);
            }
        });
    }
    $('#main-filter-form input').on('change', function () {
        var formData = $("#main-filter-form").serialize();
        ajaxFilter(formData);
    });
});



// Send main contant form
jQuery(document).ready(function ($) {
    function getValues($form) {
        var locale = $form.find('input[name="locale"]').val();
        var sender = $form.find('input[name="full-name"]').val();
        var email = $form.find('input[name="email"]').val();
        var phone = $form.find('input[name="phone"]').val();
        var message = $form.find('textarea').val();
        return { sender: sender, email: email, phone: phone, message: message, locale: locale };
    }
    function sendMessage(body) {
        grecaptcha.execute('6LffR48bAAAAAK89naQoJ2RZQkXP7BTHqFZqgZwz', { action: 'homepage' }).then(function (token) {
            body.token = token;
            $.ajax({
                url: $('#main-contact-form').attr('action'),
                method: "post",
                data: body,
                success: function (response) {
                    showResponse(response);
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });
    }
    function showResponse(response) {
        $('.validation-messages').html('');
        if (response.errors.length > 0) {
            for (var i = 0; response.errors.length > i; i++) {
                $('.validation-messages').append('<div class="validation-messages__message validation-messages__message--red">' + response.errors[i] + '</div>');
            }
        } else {
            $('.validation-messages').html('<div class="validation-messages__message validation-messages__message--green">' + response.message + '</div>');
            $('.contact-form__button').remove();
        }
        $('body').removeClass('wait');
    }
    $('#main-contact-form').submit(function (e) {
        e.preventDefault();
        sendMessage(getValues($(this)));
        $('body').addClass('wait');
    })
});
// Send product contact form
jQuery(document).ready(function ($) {
    function getPValues($form) {
        var link = $form.find('input[name="link"]').val();
        var receiver = $form.find('input[name="receiver"]').val();
        var locale = $form.find('input[name="locale"]').val();
        var sender = $form.find('input[name="full-name"]').val();
        var email = $form.find('input[name="email"]').val();
        var phone = $form.find('input[name="phone"]').val();
        var message = $form.find('textarea').val();
        return { sender: sender, email: email, phone: phone, message: message, locale: locale, receiver: receiver, link: link };
    }
    function sendPMessage(body) {
        grecaptcha.execute('6LffR48bAAAAAK89naQoJ2RZQkXP7BTHqFZqgZwz', { action: 'homepage' }).then(function (token) {
            body.token = token;
            $.ajax({
                url: $('#product-contact-form').attr('action'),
                method: "post",
                data: body,
                success: function (response) {
                    showPResponse(response);
                },
                error: function (error) {
                    console.log(error);
                }
            })
        });
    }
    function showPResponse(response) {
        $('.validation-messages').html('');
        if (response.errors.length > 0) {
            for (var i = 0; response.errors.length > i; i++) {
                $('.validation-messages').append('<div class="validation-messages__message validation-messages__message--red">' + response.errors[i] + '</div>');
            }
        } else {
            $('.validation-messages').html('<div class="validation-messages__message validation-messages__message--green">' + response.message + '</div>');
            $('.contact-form__button').remove();
        }
        $('body').removeClass('wait');
    }
    $('#product-contact-form').submit(function (e) {
        e.preventDefault();
        sendPMessage(getPValues($(this)));
        $('body').addClass('wait');
    })
});
